// extracted by mini-css-extract-plugin
export default {"mainForm":"responsiveStyles_mainForm__JWR+e","mainFormContent":"responsiveStyles_mainFormContent__smXXg","formContainer":"responsiveStyles_formContainer__HZ-fH"};